import type { Theme } from '@emotion/react';
import { type SxProps, Stack, Box } from '@mui/material';
import logo from '/public/logo.svg';
import { ROUTES } from '@shared/AppRoutes';
import { useAppNavigate } from '@shared/store';

type AppLogoProps = { sx?: SxProps<Theme> };

export const AppLogo = (props: AppLogoProps) => {
  const { sx } = props;
  const navigate = useAppNavigate();

  return (
    <Stack direction="row" spacing={1} paddingY={0.2} paddingLeft="5px" alignItems="center" sx={sx}>
      <Box
        component="a"
        onClick={() => navigate(ROUTES.home.path)}
        sx={{
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Kadeřník+ Logo"
          sx={{
            width: '130px',
            display: 'block',
            transform: 'scale(1.2)',
          }}
        />
      </Box>
    </Stack>
  );
};
